import { AnimationAction } from "three";
import { getBooleanPropBuilder } from "../FeatureUtils";

export type AnimationContextPreset = Partial<AnimationAction>;

export const AnimationContextPresets: Record<
  string,
  | AnimationContextPreset
  | ((userData: Record<string, any>) => AnimationContextPreset)
> = {
  SinglePlay: getBooleanPropBuilder("SinglePlay", {
    repetitions: 0,
    clampWhenFinished: true,
  }),
};
